let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3DNIy")).then(() => parcelRequire('44Pob'));